export default __webpack_public_path__ + "static/media/DIN.7f0f21a9.ttf";